import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import React, { Component, Fragment } from 'react';
import { Button, Col, Divider, Form, Input, Row, Tag } from 'antd';

@withRouter
@inject('store')
@observer
class GeneralFormComponent extends Component {
    componentDidMount() {
        this.props.store.strategyStore.getOdysseyStrategies();
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.store.odysseyBotStore.updateConfig(values);
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        return (
            <Fragment>
                <Row gutter={24}>
                    <Col md={8}>
                        <Form.Item label="Name" required={true}>
                            {getFieldDecorator('name', {
                                rules: [{ required: true, message: 'Field is required' }]
                            })(<Input />)}
                        </Form.Item>
                    </Col>
                    <Col md={8}>
                        <Form.Item label="Support Key" required={true}>
                            <i className="fal fa-life-ring success" />{' '}
                            <Tag>{this.props.match.params.id}</Tag>
                        </Form.Item>
                    </Col>
                </Row>
                <Divider orientation="left">API Keys</Divider>
                <Row gutter={24}>
                    <Col md={8}>
                        <Form.Item label="Api Key">
                            {getFieldDecorator('api_key')(<Input.Password />)}
                        </Form.Item>
                    </Col>

                    <Col md={8}>
                        <Form.Item label="Api Secret">
                            {getFieldDecorator('api_secret')(<Input.Password />)}
                        </Form.Item>
                    </Col>
                </Row>
                <Button onClick={this.handleSubmit.bind(this)} type="primary" size="large">
                    Save
                </Button>
                &nbsp;&nbsp;
                <Button
                    onClick={() => this.props.store.odysseyBotStore.reboot()}
                    type="danger"
                    size="large"
                >
                    Reboot
                </Button>
            </Fragment>
        );
    }
}

export const GeneralForm = Form.create({
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(k => {
            if (k === 'api_key' || k === 'api_secret') return;
            data[k] = Form.createFormField({ value: props.data[k] });
        });
        return data;
    }
})(GeneralFormComponent);



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/SettingsView/GeneralForm.js